import { LOG_SEVERITY } from '@/modules/logger/domain/logger.constants';
import { getLoggerService } from '@/modules/logger/infrastructure/loggerService';
import { getProductVerticalAndTypeByProduct } from '@/modules/product/container';

const { logger } = getLoggerService();

function isHttpError(error) {
  return error.response !== undefined || error.statusCode !== undefined;
}

function getErrorDetails(error) {
  const errorDetails = {
    statusCode: 500,
    message: error.message || 'An unknown error occurred',
    errorType: error.constructor?.name || 'Error',
    stackTrace: error.stack || 'No stack trace available',
    response: error.response?.data || 'No error response available',
  };

  if (isHttpError(error)) {
    if (error.response && error.response.status) {
      errorDetails.statusCode = error.response.status;
    } else if (error.statusCode) {
      errorDetails.statusCode = error.statusCode;
    }
  }

  return errorDetails;
}

export function logUpsellEvent({ rootGetters }, { message, tag, meta = {}, error, severity = LOG_SEVERITY.INFO }) {
  const product = rootGetters['upsell-sequence/getUpsellProduct'];
  const { vertical, type, brand } = getProductVerticalAndTypeByProduct.execute({ product });
  const payment = rootGetters['payment/getPaymentPayloadInfo'];
  const upsellName = meta?.upsellName || rootGetters['upsell-sequence/getCursorView']?.componentName || '';

  const quizId = product.tourId;
  const region = this.$countryCode;

  logger[severity](message, {
    tags: [tag],
    ...(error && { error: getErrorDetails(error) }),
    meta: {
      ...meta,
      region,
      brand,
      tour: {
        id: quizId,
        vertical,
        type,
      },
      payment,
      upsell: {
        name: upsellName,
      },
    },
  });
}

export function logSubscriptionEvent({ rootState }, { message, tag, meta = {}, error, severity = LOG_SEVERITY.ERROR }) {
  const region = this.$countryCode;
  const email = rootState.auth?.login?.email || meta?.email;
  const uuid = rootState.auth?.login?.uuid;

  logger[severity](message, {
    tags: [tag],
    ...(error && { error: getErrorDetails(error) }),
    meta: {
      ...meta,
      region,
      user: {
        email,
        uuid,
      },
    },
  });
}
